import { httpPost } from "@/api/connection";
import { CreateBulkCocRecordsFn, GetBulkUpdateTotalFn } from "./coc-api.types";

const createBulkCocRecords: CreateBulkCocRecordsFn = async (data) => {
  return await httpPost(`/evidence/bulk-coc`, data);
};

const getBulkUpdateTotal: GetBulkUpdateTotalFn = async (data) => {
  return await httpPost(`/evidence/bulk-coc/get-bulk-update-total`, data);
};

export const ChainOfCustodyAPI = {
  createBulkCocRecords,
  getBulkUpdateTotal,
};
